enum Device {
  mobile = 0,
  tablet,
  desktop
}

const useResponsiveProp = (responsiveProp: ResponsiveProp<any>, device: keyof typeof Device) => {
  if (!Array.isArray(responsiveProp)) return responsiveProp
  else {
    const { length } = responsiveProp

    if (length === 1) return responsiveProp[Device.mobile]

    if (length >= 3) return responsiveProp[Device[device]]

    if (length === 2) {
      if (device === 'desktop') device = 'tablet'
      return responsiveProp[Device[device]]
    }
  }
}

export default useResponsiveProp
